import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{}>;

export const DispatchClearPreSelectAttributes: HandlerType = props => {
    (props as any).dispatch({
        type: "Custom/PreSelectAttributes/SetData",
        payload: {
            categoryId: "",
            isPreselectDataLoaded: false,
        },
    });
};

export const chain = [DispatchClearPreSelectAttributes];

const clearPreSelectAttributes = createHandlerChainRunnerOptionalParameter(chain, {}, "ClearPreSelectAttributes");

export default clearPreSelectAttributes;
